import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'
import {HttpSearchRepository} from '../Repositories/HttpSearchRepository.js'
import {GetAIFaqsForUrlSearchRequest} from '../Request/GetAIFaqsForUrlSearchRequest.js'

class GetAIFaqsForUrlSearchUseCase extends UseCase {
  #config
  #repository

  static create({config}) {
    return new GetAIFaqsForUrlSearchUseCase({config, repository: HttpSearchRepository.create({config})})
  }

  constructor({config, repository}) {
    super()
    this.#config = config
    this.#repository = repository
  }

  @tracer({metric: 'GetAIFaqsForUrlSearchUseCase#execute'})
  @AsyncInlineError()
  async execute({listingSectionId, pageType, search, path}) {
    if (!path)
      return Promise.reject(InvalidParamsSharedError.create('[GetAIFaqsForUrlSearchUseCase#execute] path is required'))

    const getAIFaqsRequest = GetAIFaqsForUrlSearchRequest.createFromSearch({
      config: this.#config,
      listingSectionId,
      pageType,
      search
    })

    const [error, response] = await this.#repository.getAIFaqsForUrlSearch({getAIFaqsRequest, path})

    if (error) return Promise.reject(error)

    return response
  }
}

export const factory = GetAIFaqsForUrlSearchUseCase.create
